/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 28/09/2021
 */

const verifyPhoneRequest = () => {
    return {
        telefono: null,
        password: null,
        password_confirm:null,
        client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID,
    }
}

export default verifyPhoneRequest;